<template>
  <dara-item-table-layout>
    <template #avatar>
      <dara-p class="gray-text">
        {{ $t('avatar') }}
      </dara-p>
    </template>
    <template #name>
      <div @click="orderBy('name')">
        <dara-p class="header cursor--pointer" :class="selected === 'name' ? 'selected' : ''">
          {{ $t('user-name') }}
          <i v-if="nameOrder == 'ASC'" class="el-icon-arrow-down" />
          <i v-else class="el-icon-arrow-up" />
        </dara-p>
      </div>
    </template>
    <template #firstColumn>
      <div @click="orderBy('total_rating')">
        <dara-user-badge class="gray-image" :class="selected === 'total_rating' ? 'selected' : ''" badge="best-writer" offset-y="3.4" offset-x="-3.6" />
        <dara-p class="header cursor--pointer ml--xl" :class="selected === 'total_rating' ? 'selected' : ''">
          {{ $t('total-rating') }}
          <i v-if="order == 'DESC'" class="el-icon-arrow-down" />
          <i v-else class="el-icon-arrow-up" />
        </dara-p>
      </div>
    </template>
    <template #secondColumn>
      <div @click="orderBy('created_articles')">
        <dara-user-badge class="gray-image" :class="selected === 'created_articles' ? 'selected' : ''" badge="top-writer" offset-y="3.4" offset-x="-3.6" />
        <dara-p class="header cursor--pointer ml--xl" :class="selected === 'created_articles' ? 'selected' : ''">
          {{ $t('created-articles') }}
          <i v-if="order == 'DESC'" class="el-icon-arrow-down" />
          <i v-else class="el-icon-arrow-up" />
        </dara-p>
      </div>
    </template>
    <template #thirdColumn>
      <div @click="orderBy('readed_articles')">
        <dara-user-badge class="gray-image" :class="selected === 'readed_articles' ? 'selected' : ''" badge="top-reader" offset-y="3.4" offset-x="-3.6" />
        <dara-p class="header cursor--pointer ml--xl" :class="selected === 'readed_articles' ? 'selected' : ''">
          {{ $t('readed-articles') }}
          <i v-if="order == 'DESC'" class="el-icon-arrow-down" />
          <i v-else class="el-icon-arrow-up" />
        </dara-p>
      </div>
    </template>
    <template #fourthColumn>
      <div @click="orderBy('followers')">
        <dara-p class="header cursor--pointer" :class="selected === 'followers' ? 'selected' : ''">
          {{ $t('new-followers') }}
          <i v-if="order == 'DESC'" class="el-icon-arrow-down" />
          <i v-else class="el-icon-arrow-up" />
        </dara-p>
      </div>
    </template>
  </dara-item-table-layout>
</template>

<script>
import DaraItemTableLayout from '@/layouts/ItemTableLayout.vue';
import DaraUserBadge from '@/modules/user/components/UserBadge.vue';

export default {
  name: 'DaraUserRankingHeader',
  components: {
    DaraItemTableLayout,
    DaraUserBadge,
  },
  data() {
    return {
      selected: 'total_rating',
      nameOrder: 'ASC',
      order: 'DESC',
    };
  },
  methods: {
    invertOrder(order) {
      return order === 'ASC' ? 'DESC' : 'ASC';
    },
    orderBy(column) {
      if (this.selected === column) {
        this.nameOrder = this.invertOrder(this.nameOrder);
        this.order = this.invertOrder(this.order);
        if (column === 'name') {
          this.$emit('orderBy', { by: column, order: this.nameOrder });
        } else {
          this.$emit('orderBy', { by: column, order: this.order });
        }
      } else {
        this.selected = column;
        const order = column === 'name' ? this.nameOrder : this.order;
        this.$emit('orderBy', { by: column, order });
      }
    },
  },
};
</script>

<style scoped>

  .gray-image {
    filter: grayscale(100%);
    opacity: 0.5;
  }
  .gray-text {
    color: #868E96 !important;
  }
  .header {
    color: #868E96 !important;
    font-size: 14px !important;
  }
  .header:hover {
    color: #409eff !important;
  }
  .selected {
    color: #409eff !important;
    filter: grayscale(0%) !important;
    opacity: 1 !important;
  }

</style>
